import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';

type MetricCardProps = {
  header: ReactNode;
  value: string | ReactNode;
  auxiliaryData?: string | ReactNode;
  className?: string;
};

export default function MetricCard({
  header,
  value,
  auxiliaryData,
  className,
}: MetricCardProps) {
  return (
    <div
      className={clsx(
        'flex min-h-[8.75rem] flex-col justify-between rounded-md border border-gray-200 border-l-[3px] px-3.5 py-3',
        className,
      )}
    >
      <div className="flex flex-col gap-1">
        <div className="text-xs font-semibold uppercase tracking-[0.14em] text-gray-500">
          {header}
        </div>
        <div className="flex min-w-0 items-baseline gap-1 text-xl font-semibold tracking-tight text-gray-950">
          {value}
        </div>
      </div>
      {auxiliaryData ? (
        <div className="text-[11px] font-medium text-gray-700">
          {auxiliaryData}
        </div>
      ) : null}
    </div>
  );
}
